module.exports = __webpack_public_path__ + "static/media/arrow-from-left.3173f65c.svg";